<template>
  <div>
    <div class="container">
      <Breadcrumbs />
      <q-card>
        <q-tabs :value="activeTab" @input="changeTab" dense align="justify" class="tab" narrow-indicator>
          <q-tab name="automatic" label="Indicadores automáticos (GUD)" />
          <q-tab name="manual" label="Indicadores manuales" />
        </q-tabs>
        <q-separator class="separator"></q-separator>
        <q-tab-panels v-model="activeTab" animated>
          <q-tab-panel name="automatic">
            <div class="row">
              <div class="col-12 dBtn">
                <q-btn disable data-cy="bNewCity" unelevated class="bPrincipal">
                  CREAR NUEVO INDICADOR
                </q-btn>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <AdminListadoAuto />
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="manual">
            <div class="row">
              <div class="col-12 dBtn">
                <q-btn data-cy="bNewCity" class="bPrincipal" @click="createmanual()">
                  CREAR NUEVO INDICADOR PROPIO
                </q-btn>
                <PopUpCreacionIndicadorManual  v-if="showPopUpEdicionIndicador" v-model="showPopUpEdicionIndicador" :datosIndicador="datosIndicador" @saveDetalleIndicadorManual="saveDetalleIndicadorManual"/>
              </div>
            </div>
            <div class="row">
              <div class="row col-12">
                <div class="col-12">
                  <AdminListadoManual />
                </div>
              </div>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card>
    </div>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import AdminListadoManual from '../components/AdminListadoManual.vue';
import AdminListadoAuto from '../components/AdminListadoAuto.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import { QTab, QTabPanel, QTabPanels, QTabs } from 'quasar';
import PopUpCreacionIndicadorManual from '@/components/Indicadores/components/PopUpCreacionIndicadorManual.vue';
import * as types from '@/storeModules/NGUD/types';

export default {
  mixins: [Message],
  components: { AdminListadoAuto, Breadcrumbs, QTab, QTabs, QTabPanel, QTabPanels, PopUpCreacionIndicadorManual, AdminListadoManual },
  data () {
    return {
      activeTab: 'automatic',
      showPopUpEdicionIndicador: false,
      datosIndicador: {}
    };
  },
  methods: {
    changeTab (val) {
      this.activeTab = val;
    },

    createmanual () {
      this.showPopUpEdicionIndicador = true;
    },
    async saveDetalleIndicadorManual (newDato) {
      await this.$store.dispatch(types.ACTION_SAVE_INDICADOR_MANUAL, { dataIndicador: newDato })
        .then(() => {
          this.showPopUpEdicionIndicador = false;
        })
        .then(() => {
          this.$store
            .dispatch(types.ACTION_GET_ALL_INDICADORES)
            .catch((err) => { console.warn('err', err); });
        })
        .catch((e) => { console.warn('error', e); });
    }

  }
};
</script>

<style lang="scss" scoped>
.bPrincipal {
  float: right;
}
.dBtn {
  margin-bottom: 15px;
}
::v-deep {
  div.tab {
    margin-top: 10px;
    width: 66%;
    border-radius: 0px;
  }
  .q-separator {
    height: 0px !important;
  }
  .separator {
    height: 4px !important;
    background: #e9f4f6 !important;
  }
  div.q-tab__indicator.q-tab__indicator {
    color: #67d2df !important;
    height: 3px;
  }
  div.q-tab__label {
    color: #002f6c;
    text-transform: capitalize !important;
    font-weight: bold;
  }
  div.q-tab__label,
  .divLink {
    font-family: DINPro;
    font-size: 17px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.68px;
  }
  .divLink {
    font-weight: 500;
    color: #565656;
    margin-bottom: 20px;
    margin-top: 15px;
  }
  a {
    text-decoration: none;
  }
  .q-expansion-item {
    width: 100%;
  }
  .q-expansion-item:hover {
    background-color: rgba(253, 249, 249, 0.295);
  }
}
</style>
